import React from 'react';
import { useMutation, useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import api from '../../../../components/api';

function useModelManagement() {
  const [searchValue, setSearchValue] = React.useState<string>('');
  const [currentPage, setCurrentPage] = React.useState<number>(1);
  const { data: modelRes, isLoading: modelLoad, refetch: refetchModel } = useQuery(
    ['getAllModel', 'vendingMachine', currentPage - 1, 20],
    () => api.vendingMachine.getAllModel(currentPage - 1, 10),
  );

  const modelList = React.useMemo(() => ({
    list: modelRes?.data?.data,
    totalPage: modelRes?.data?.totalPages ?? 1,
  }), [modelRes]);

  const [result, setResult] = React.useState<any>();
  const { mutate: deleteModel, isLoading: deleteModelLoad } = useMutation(api.vendingMachine.deleteModel, {
    onMutate: (variables) => console.log(variables),
    onSuccess: (data) => {
      setResult(data);
      console.log(data);
    },
    onError: (error) => {
      setResult(error);
      console.log(error);
    },
  });
  const handleDelete = (id: number) => deleteModel(id);
  const onAfterDelete = () => {
    refetchModel().catch((e) => console.log(e));
    setResult(undefined);
  };

  // navigation handler
  const navigation = useNavigate();
  const onNavigateToAdd = () => navigation('/vending-machine/model-management/add');

  return {
    search: {
      current: searchValue,
      setCurrent: setSearchValue,
    },
    page: {
      current: currentPage,
      setCurrent: setCurrentPage,
    },
    model: {
      list: modelList.list,
      totalPage: modelList.totalPage,
      load: modelLoad,
    },
    configDelete: {
      handler: handleDelete,
      after: onAfterDelete,
      load: deleteModelLoad,
      result,
    },
    navigation: {
      add: onNavigateToAdd,
    },
  };
}

export default useModelManagement;
